<script>

import { Overlay } from '../../'
import { standardIndicator } from '../../workspace/standard-indicators.mjs'

export default {
    name: 'Vortex',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Vortex Indicator - Identifies trend changes and directional movement',
                preset: {
                    name: 'Vortex $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        plusColor: '#26a69a',
                        minusColor: '#ef5350'
                    }
                }
            }
        },
        use_for() { return ['Vortex'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' }
                },
                conf: { renderer: 'Splines' },
                update: `const count = Math.max(2, Math.floor(length)) * 2 + 1;
                    const values = series => Array.from({length:count},(_,i)=>series[i]);
                    return (${standardIndicator.toString()})('Vortex',values(high),values(low),values(close),[],length);`
            }
        }
    }
}
</script>
